import { defaultParams, STORAGE_KEY, FOLDERS_KEY } from './defaults.js'
import { builtinPresets } from './presets.js'

const firstPreset = Object.values(builtinPresets)[0] || {}
export const params = { ...defaultParams, ...firstPreset }

try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY))
    if (saved) Object.assign(params, saved)
} catch(e) {}

export const saveParams = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(params))
}

export const loadFolderState = () => {
    try {
        return JSON.parse(localStorage.getItem(FOLDERS_KEY)) || {}
    } catch(e) {
        return {}
    }
}

export const saveFolderState = (state) => {
    localStorage.setItem(FOLDERS_KEY, JSON.stringify(state))
}
